export default __webpack_public_path__ + "static/media/team2.8730a170.jpg";